<template>
  <span
    class="notranslate"
    v-html="total"
  />
</template>

<style scoped>
</style>

<script>
import CurrencyApi from './currency-api.js'

export default {
  props: ['amount', 'currency'],
  data: function() {
    return {
      total: '',
      locale: 'en-US'
    }
  },
  watch: {
    amount() {
      this.setCurrency()
    },
    currency() {
      this.setCurrency()
    }
  },
  created() {
    this.locale = navigator.language || 'en-US'
    this.setCurrency()
  },
  methods: {
    setCurrency() {
      var total = Number(this.amount).toFixed(2)
      if (this.currency == 'USD') {
        this.total = '$' + total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        this.total = CurrencyApi.formatAmount(total, this.currency)
      }
    }
  }
}
</script>
